import React from "react";
import SEO from "../components/SEO";
import Layout from "../components/Layout";
import ServiceCard from "../components/ServiceCard";
import CTA from "../components/CTA";
import services from "../data/services";

const Services = () => (
  <Layout>
    <SEO title="Services" description="Eleven technology and internet services delivered by Atlas Brokerage — software, networking, cloud, security, data and managed IT." />

    <section className="service-hero">
      <div className="container">
        <div className="crumbs">
          <a href="/">Home</a><span className="sep">/</span> Services
        </div>
        <span className="eyebrow eyebrow--light">What we do</span>
        <h1>Eleven services, delivered under one accountable team.</h1>
        <p className="lead">
          We combine technology services that are normally bought from a dozen different suppliers — CRM, custom software,
          networks, voice, cloud, security, data, hosting and managed operations — into one cohesive practice with shared
          delivery standards and a single point of accountability.
        </p>
      </div>
    </section>

    <section className="section section--paper">
      <div className="container">
        <div className="grid grid--3">
          {services.map((s, i) => (
            <ServiceCard key={s.slug} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>

    <CTA
      eyebrow="Engage Atlas"
      title="Not sure where to start? Neither are most of our clients on day one."
      text="Tell us what is hurting today. We will help you decide whether the answer is one service, several, or a longer programme."
    />
  </Layout>
);

export default Services;
